export const emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(?!(?:hide.biz|yopmail)\.(?:st|net)$)(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export default {
  validate: (rules, values, errors) => {
    for (const error in errors) {
      if (errors.hasOwnProperty(error)) {
        errors[error] = false;
      }
    }

    let error = false;
    for (const name in rules) {
      if (!rules.hasOwnProperty(name) || !errors.hasOwnProperty(name)) {
        continue;
      }

      if (!new RegExp(rules[name]).test(values[name] || "")) {
        console.log(name, `${values[name]} test failed: ${rules[name]}`);
        error = true;
        errors[name] = true;
      } else {
        console.log(name, `${values[name]} test success: ${rules[name]}`);
      }
    }

    return !error;
  }
};
